import gql from 'graphql-tag';
import { kmsClient } from 'api/index';
import { useQuery } from '@apollo/react-hooks';
import { ArticleAssets, ArticleAssetsVariables } from './__generated__/ArticleAssets';

const ARTICLE_ASSETS = gql`
  query ArticleAssets($articleId: ID!) {
    articleAssets(articleId: $articleId) {
      id
      value
      type
      googleAds {
        id
        resourceName
        googleAdGroup {
          id
          resourceName
          googleCampaign {
            id
            resourceName
          }
        }
      }
    }
  }
`;

export const useArticleAssetsQuery = (variables: ArticleAssetsVariables) => {
  return useQuery<ArticleAssets, ArticleAssetsVariables>(ARTICLE_ASSETS, {
    variables,
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
